export class ReplyEmail {
  public contentTitle?: string;
  public contentBody?: string;
  public contentFooter?: string;
  public emailLog?: any;
}
